import { render } from "./CreateBannerComponent.vue?vue&type=template&id=6c428c8c"
import script from "./CreateBannerComponent.vue?vue&type=script&lang=js"
export * from "./CreateBannerComponent.vue?vue&type=script&lang=js"

import "./CreateBannerComponent.vue?vue&type=style&index=0&id=6c428c8c&lang=scss"

import exportComponent from "/var/www/nexgen/apps/admin/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__